
/**
 * @export
 * @class Settings
 */

export namespace Settings {
  export abstract class DateFormats {
    public static readonly dateFormatBackend = "DD-MM-yyyy";
    public static readonly dateFormatFrontend = "yyyy-MM-DD HH:mm:ss";
    public static readonly dateFormatOnlyDate = "yyyy-MM-DD";
  }
  export abstract class AutoRefreshTime {
    public static readonly refreshTimeInMilliSeconds = 900000; //900000 milli-seconds are 15 minutes
  }
  export abstract class GridConfiguration {
    public static readonly pageNumber: number = 1;
    public static readonly pageSize: number = 25;
    public static readonly pageSizeList: number[] = [10,25,50, 75, 100];
    public static readonly totalRecords: number = 0;
    public static readonly orderBy: String = "";
    public static readonly orderType: Number = 1;
    public static readonly disposalActionList: {}[] = [{ name: "DELETE" }, { name: "REVIEW" }, { name: "ARCHIVE" }]
  }
  export abstract class Status {
    public static readonly booleanStatusList: {}[] = [{ id: true, name: "Active" }, { id: false, name: "Inactive" }]
    public static readonly booleanList: {}[] = [{ id: true, name: "True", code: "YES" }, { id: false, name: "False", code: "NO" }]
  }
  export abstract class Feature {
    public static readonly featureList: any[] = [{ id: 1, name: "EXTRACTION" }, { id: 5, name: "EXTRACTION + AUDITING" }]
  }
  export abstract class DirectionType {
    public static readonly directions: any[] = [{ id: 5, name: "GET" }, { id: 10, name: "POST" }]
  }
  export abstract class ReportType {
    public static readonly fetchReportType: any[] = [{ id: 1, name: "Daily" }, { id: 2, name: "Weekly" }, { id: 3, name: "Monthly" }, { id: 4, name: "Quaterly" }, { id: 5, name: "Annually" }]
  }
  export abstract class ConnectionProtocol {
    public static readonly connectionList: any[] = [
      { id: 5, name: "SMTP" },
      { id: 10, name: "SFTP" },
      { id: 15, name: "FTP" },
      // { id: 4, name: "FSA" },
      // { id: 5, name: "API" },
      // { id: 6, name: "AS2" },
    ]
  }
  export abstract class Company {
    public static readonly companyType: any[] = [
      { id: 5, name: "CUSTOMER" },
      { id: 10, name: "VENDOR" }
    ]
  }
  export abstract class Address {
    public static readonly addressType: any[] = [+
      { id: 5, name: "Headquarters" },
      { id: 10, name: "Corporate Office" },
      { id: 15, name: "Branch Office" },
      { id: 20, name: "Regional Office" }
    ]
  }
  export abstract class Service {
    public static readonly serviceCategory: any[] = [
      // { id: 5, name: "Product" },
      { id: 10, name: "Service" }
    ]
  }
  export abstract class Transport {
    public static readonly transportMode: any[] = [
      { id: 5, name: "Rail" },
      { id: 10, name: "Road" },
      { id: 15, name: "Ocean" },
      { id: 20, name: "Air" },
    ]
  }
  export abstract class ValidationEnum {
    public static readonly validationKeys: any[] = [
      { id: 10, name: "NAME" },
      { id: 5, name: "SBU_VAT_ID" },
      // { id: 15, name: "IBAN" },
      { id: 20, name: "ZIP_CODE" },
      { id: 25, name: "CITY" },
    ]
  }
  // export abstract class ModuleCategory {
  //   public static readonly categoryType: any[] = [
  //     { id: 5, name: "VENDOR" },
  //     { id: 10, name: "CUSTOMER" }
  //   ]
  // }
  export abstract class Operation {
    public static readonly operationType: any[] = [
      { id: 5, name: "VALIDATION" },
      { id: 10, name: "TRANSFORMATION" }
    ]
  }

  export enum FormFieldType {
    "input" = "Text Box",
    "dropdown" = "Dropdown",
    "multiselect" = "MultiSelect",
    "radiobutton" = "Radio Button",
    "calendar" = "Calendar"
  }
  export enum ActionType {
    D = "DELETE",
    I = "INSERT",
    S = "SELECT/SEARCH",
    U = "UPDATE",
    E = "EXPORT"
  }
  export enum EmailTemplateFormat {
    "Email" = 1,
    "Domain" = 2,
    "Email Regex" = 3
  }
  export abstract class PrivilegeList {
   public static readonly rolePrivilegeList = [
      {
        module: 'Documents', id: 5,visible:true,
        items: [
          { id: 5, name: 'View Document Detail', value: 'VIEW_DOCUMENT_DETAIL' },
          { id: 5, name: 'Add', value: 'CREATE_DOCUMENT' },
          { id: 5, name: 'Update', value: 'UPDATE_DOCUMENT_DETAIL' },
          { id: 5, name: 'View', value: 'VIEW_DOCUMENT_LIST' },
        ]
      },
      {
        module: 'Administration: User Management', id: 10,visible:true,
        items: [
          { id: 10, name: 'View', value: 'VIEW_USER_LIST' },
          { id: 10, name: 'Add', value: 'CREATE_USER' },
          { id: 10, name: 'Update', value: 'UPDATE_USER' }
          // { id: 10, name: 'View User Detail', value: 'VIEW_USER' },
        ]
      },
      {
        module: 'Administration: Role Management', id: 15,visible:true,
        items: [
          { id: 15, name: 'View', value: 'VIEW_ROLE_LIST' },
          { id: 15, name: 'Add', value: 'CREATE_ROLE' },
          { id: 15, name: 'Update', value: 'UPDATE_ROLE' }
        ]
      },
      // {
      //   module: 'Administration: System Announcement', id: 45,visible:false,
      //   items: [
      //     { id: 45, name: 'View', value: 'VIEW_SYSTEM_ANNOUNCEMENT_LIST' },
      //     { id: 45, name: 'Add', value: 'CREATE_SYSTEM_ANNOUNCEMENT' },
      //     { id: 45, name: 'Update', value: 'UPDATE_SYSTEM_ANNOUNCEMENT' },
      //     { id: 45, name: 'Delete', value: 'DELETE_SYSTEM_ANNOUNCEMENT' },
      //   ]
      // },
      {
        module: 'Master Data: Rate Card Management', id: 55,visible:true,
        items: [
          { id: 55, name: 'View', value: 'VIEW_RATE_CARD_LIST' },
          { id: 55, name: 'Retrieve', value: 'RETRIEVE_RATE_CARD' },
          { id: 55, name: 'Add', value: 'CREATE_RATE_CARD' },
          { id: 55, name: 'Update', value: 'UPDATE_RATE_CARD' },
          { id: 55, name: 'Delete', value: 'DELETE_RATE_CARD' },
        ]
      },
      {
        module: 'Master Data: Shipment Management', id: 65,visible:true,
        items: [
          { id: 65, name: 'View', value: 'VIEW_SHIPMENT_LIST' },
          { id: 65, name: 'Retrieve', value: 'VIEW_SHIPMENT_DETAIL' },
          { id: 65, name: 'Create', value: 'CREATE_SHIPMENT' },
          { id: 65, name: 'Update', value: 'UPDATE_SHIPMENT_DETAIL' },
          { id: 65, name: 'Delete', value: 'DELETE_SHIPMENT_DETAIL' }
        ]
      },
      // {
      //   module: 'Master Data: Currency Exchange', id: 70,visible:false,
      //   items: [
      //     { id: 70, name: 'View', value: 'VIEW_CURRENCY_EXCHANGE_LIST' },
      //     { id: 70, name: 'Add', value: 'CREATE_CURRENCY_EXCHANGE' },
      //     { id: 70, name: 'Update', value: 'UPDATE_CURRENCY_EXCHANGE' },
      //     { id: 70, name: 'Delete', value: 'DELETE_CURRENCY_EXCHANGE' },
      //   ]
      // },
      {
        module: 'Administration: Column Settings', id: 80,visible:true,
        items: [
          { id: 70, name: 'View', value: 'VIEW_COLUMN_SETTING_LIST' },
          { id: 70, name: 'Add', value: 'CREATE_COLUMN_SETTING_BULK' },
          { id: 70, name: 'Update', value: 'UPDATE_COLUMN_SETTING' },
          { id: 70, name: 'Delete', value: 'DELETE_COLUMN_SETTING' },
        ]
      },
      {
        module: 'Administration: Client Management', id: 90,visible:false,
        items: [
          { id: 90, name: 'View', value: 'VIEW_CLIENT_LIST' },
          { id: 90, name: 'Add', value: 'CREATE_CLIENT' },
          { id: 90, name: 'Update', value: 'UPDATE_CLIENT' },
          { id: 90, name: 'Delete', value: 'DELETE_CLIENT' },
        ]
      },
      {
        module: 'Administration: Document Type', id: 100,visible:false,
        items: [
          { id: 100, name: 'View', value: 'VIEW_DOCUMENT_TYPE_LIST' },
          { id: 100, name: 'Add', value: 'CREATE_DOCUMENT_TYPE' },
          { id: 100, name: 'Update', value: 'UPDATE_DOCUMENT_TYPE' },
          { id: 100, name: 'Delete', value: 'DELETE_DOCUMENT_TYPE' },
        ]
      },
      {
        module: 'Administration: File Type', id: 105,visible:false,
        items: [
          { id: 105, name: 'View', value: 'VIEW_FILE_TYPE_LIST' },
          { id: 105, name: 'Add', value: 'CREATE_FILE_TYPE' },
          { id: 105, name: 'Update', value: 'UPDATE_FILE_TYPE' },
          { id: 105, name: 'Delete', value: 'DELETE_FILE_TYPE' },
        ]
      },
      {
        module: 'Administration: Rate Sheet', id: 110,visible:false,
        items: [
          { id: 110, name: 'View', value: 'VIEW_CHARGE_SHEET_LIST' },
          { id: 110, name: 'Add', value: 'CREATE_CHARGE_SHEET' },
          { id: 110, name: 'Update', value: 'UPDATE_CHARGE_SHEET' },
          { id: 110, name: 'Delete', value: 'DELETE_CHARGE_SHEET' },
        ]
      },
      {
        module: 'Master Data: Currency Management', id: 125,visible:false,
        items: [
          { id: 125, name: 'View', value: 'VIEW_CURRENCY_LIST' },
          { id: 125, name: 'Add', value: 'CREATE_CURRENCY' },
          { id: 125, name: 'Update', value: 'UPDATE_CURRENCY' },
          { id: 125, name: 'Delete', value: 'DELETE_CURRENCY' },
        ]
      },
      // {
      //   module: 'Administration: Auto Email Template', id: 130,visible:false,
      //   items: [
      //     { id: 130, name: 'View', value: 'EMAIL_TEMPLATE_AUTO_LIST_VIEW' },
      //     { id: 130, name: 'Add', value: 'EMAIL_TEMPLATE_AUTO_CREATE' },
      //     { id: 130, name: 'Update', value: 'EMAIL_TEMPLATE_AUTO_UPDATE' },
      //     { id: 130, name: 'Delete', value: 'EMAIL_TEMPLATE_AUTO_DELETE' },
      //   ]
      // },
      // {
      //   module: 'Administration: Manual Email Template (Public)', id: 135,visible:false,
      //   items: [
      //     { id: 135, name: 'View', value: 'EMAIL_TEMPLATE_MANUAL_LIST_VIEW' },
      //     { id: 135, name: 'Add', value: 'EMAIL_TEMPLATE_MANUAL_CREATE' },
      //     { id: 135, name: 'Update', value: 'EMAIL_TEMPLATE_MANUAL_UPDATE' },
      //     { id: 135, name: 'Delete', value: 'EMAIL_TEMPLATE_MANUAL_DELETE' },
      //     { id: 135, name: 'View Usage Count', value: 'EMAIL_TEMPLATE_USAGE_LIST_VIEW' },
      //   ]
      // },
      // {
      //   module: 'Administration: Manual Email Template (Private)', id: 140,visible:false,
      //   items: [
      //     { id: 140, name: 'Add', value: 'EMAIL_TEMPLATE_MANUAL_PRIVATE_CREATE' },
      //     { id: 140, name: 'Update', value: 'EMAIL_TEMPLATE_MANUAL_PRIVATE_UPDATE' },
      //     { id: 140, name: 'Delete', value: 'EMAIL_TEMPLATE_MANUAL_PRIVATE_DELETE' },
      //   ]
      // },
      // {
      //   module: 'Master Data: ZIP Code Alias', id: 155,visible:false,
      //   items: [
      //     { id: 155, name: 'View', value: 'VIEW_ZIP_ALIAS_LIST' },
      //     { id: 155, name: 'Add', value: 'CREATE_ZIP_ALIAS' },
      //     { id: 155, name: 'Update', value: 'UPDATE_ZIP_ALIAS' },
      //     { id: 155, name: 'Delete', value: 'DELETE_ZIP_ALIAS' },
      //   ]
      // },
      // {
      //   module: 'Master Data: City Alias', id: 160,
      //   items: [
      //     { id: 160, name: 'View', value: 'VIEW_CITY_ALIAS_LIST' },
      //     { id: 160, name: 'Add', value: 'CREATE_CITY_ALIAS' },
      //     { id: 160, name: 'Update', value: 'UPDATE_CITY_ALIAS' },
      //     { id: 160, name: 'Delete', value: 'DELETE_CITY_ALIAS' },
      //   ]
      // },
      // {
      //   module: 'Master Data: Currency Alias', id: 145,visible:false,
      //   items: [
      //     { id: 145, name: 'View', value: 'VIEW_CURRENCY_ALIAS_LIST' },
      //     { id: 145, name: 'Add', value: 'CREATE_CURRENCY_ALIAS' },
      //     { id: 145, name: 'Update', value: 'UPDATE_CURRENCY_ALIAS' },
      //     { id: 145, name: 'Delete', value: 'DELETE_CURRENCY_ALIAS' },
      //   ]
      // },
      // {
      //   module: 'Master Data: VAT Alias', id: 165,visible:false,
      //   items: [
      //     { id: 165, name: 'View', value: 'VIEW_VAT_ALIAS_LIST' },
      //     { id: 165, name: 'Add', value: 'CREATE_VAT_ALIAS' },
      //     { id: 165, name: 'Update', value: 'UPDATE_VAT_ALIAS' },
      //     { id: 165, name: 'Delete', value: 'DELETE_VAT_ALIAS' },
      //   ]
      // },
      // {
      //   module: 'Administration: Error Code List', id: 170,visible:false,
      //   items: [
      //     { id: 170, name: 'View', value: 'VIEW_ERROR_CODE_LIST' },
      //     { id: 170, name: 'Add', value: 'CREATE_ERROR_CODE' },
      //     { id: 170, name: 'Update', value: 'UPDATE_ERROR_CODE' },
      //     { id: 170, name: 'Delete', value: 'DELETE_ERROR_CODE' },
      //   ]
      // },
      // {
      //   module: 'Administration: Document Actions Management', id: 190,visible:false,
      //   items: [
      //     { id: 190, name: 'View', value: 'VIEW_ACTION_STATUS_LIST' },
      //     { id: 190, name: 'Add', value: 'CREATE_ACTION_STATUS' },
      //     { id: 190, name: 'Update', value: 'UPDATE_ACTION_STATUS' }
      //   ]
      // },
      {
        module: 'Administration: Billing', id: 200,visible:false,
        items: [
          { id: 200, name: 'View', value: 'VIEW_BILLING_LIST' },
        ]
      },
      // {
      //   module: 'Master Data: CHARGE Type', id: 330,visible:true,
      //   items: [
      //     { id: 330, name: 'View', value: 'VIEW_CHARGE_TYPE_LIST' },
      //     { id: 330, name: 'Add', value: 'CREATE_CHARGE_TYPE' },
      //     { id: 330, name: 'Update', value: 'UPDATE_CHARGE_TYPE' },
      //     { id: 330, name: 'Delete', value: 'DELETE_CHARGE_TYPE' },
      //     { id: 330, name: 'Retrieve', value: 'RETRIEVE_CHARGE_TYPE' },
      //   ]
      // },
      {
        module: 'Master Data: UOM Management', id: 230,visible:true,
        items: [
          { id: 230, name: 'View', value: 'VIEW_UOM_LIST' },
          // { id: 230, name: 'Retrieve', value: 'RETRIEVE_UOM' },
          { id: 230, name: 'Add', value: 'CREATE_UOM' },
          { id: 230, name: 'Update', value: 'UPDATE_UOM' },
          { id: 230, name: 'Delete', value: 'DELETE_UOM' },
        ]
      },
      {
        module: 'Master Data: Customer Master Data', id: 240,visible:true,
        items: [
          { id: 240, name: 'View', value: 'CUSTOMER_LIST' },
          // { id: 240, name: 'Retrieve', value: 'VIEW_CUSTOMER' },
          { id: 240, name: 'Add', value: 'CREATE_CUSTOMER' },
          { id: 240, name: 'Update', value: 'UPDATE_CUSTOMER' }
        ]
      },
      {
        module: 'Master Data: Vendor Management', id: 250,visible:true,
        items: [
          { id: 250, name: 'View', value: 'VENDOR_LIST' },
          { id: 250, name: 'Add', value: 'CREATE_VENDOR' },
          { id: 250, name: 'Update', value: 'UPDATE_VENDOR' }
        ]
      },
      {
        module: 'Master Data: Surcharge Management', id: 320, visible:true,
        items: [
          { id: 320, name: 'View', value: 'VIEW_SURCHARGE_LIST' },
          { id: 320, name: 'Retrieve', value: 'RETRIEVE_SURCHARGE' },
          { id: 320, name: 'Add', value: 'CREATE_SURCHARGE' },
          { id: 320, name: 'Update', value: 'UPDATE_SURCHARGE' },
          { id: 320, name: 'Delete', value: 'DELETE_SURCHARGE' },
        ]
      },
      {
        module: 'Master Data: Surcharge Code Library', id: 350,visible:true,
        items: [
          { id: 350, name: 'View', value: 'VIEW_NAME_SURCHARGE_CODE_LIBRARY' },
          { id: 350, name: 'Retrieve', value: 'RETRIEVE_SURCHARGE_CODE_LIBRARY' },
          { id: 350, name: 'Add', value: 'CREATE_SURCHARGE_CODE_LIBRARY' },
          { id: 350, name: 'Update', value: 'UPDATE_SURCHARGE_CODE_LIBRARY' },
          { id: 350, name: 'DELETE', value: 'DELETE_SURCHARGE_CODE_LIBRARY' }
        ]
      },
      // {
      //   "module": "Master Data: Surcharge Code Library",
      //   "id": 350,
      //   "visible": true,
      //   "items": [
      //     { "id": 350, "name": "Create", "value": "CREATE_SURCHARGE_CODE_LIBRARY" },
      //     { "id": 350, "name": "View", "value": "VIEW_NAME_SURCHARGE_CODE_LIBRARY" },
      //     { "id": 350, "name": "Retrieve", "value": "RETRIEVE_SURCHARGE_CODE_LIBRARY" },
      //     { "id": 350, "name": "Update", "value": "UPDATE_SURCHARGE_CODE_LIBRARY" },
      //     { "id": 350, "name": "Delete", "value": "DELETE_SURCHARGE_CODE_LIBRARY" }
      //   ]
      // },
      {
        "module": "Master Data: Surcharge Tolerance",
        "id": 355,
        "visible": true,
        "items": [
          { "id": 355, "name": "View", "value": "VIEW_NAME_SURCHARGE_TOLERANCE" },
          { "id": 355, "name": "Retrieve", "value": "RETRIEVE_SURCHARGE_TOLERANCE" },
          { "id": 355, "name": "Add", "value": "CREATE_SURCHARGE_TOLERANCE" },
          { "id": 355, "name": "Update", "value": "UPDATE_SURCHARGE_TOLERANCE" },
          { "id": 355, "name": "Delete", "value": "DELETE_SURCHARGE_TOLERANCE" }
        ]
      },
      {
        "module": "Master Data: Charge Type",
        "id": 330,
        "visible": true,
        "items": [
          { "id": 330, "name": "View", "value": "VIEW_CHARGE_TYPE_LIST" },
          { "id": 330, "name": "Retrieve", "value": "RETRIEVE_CHARGE_TYPE" },
          { "id": 330, "name": "Add", "value": "CREATE_CHARGE_TYPE" },
          { "id": 330, "name": "Update", "value": "UPDATE_CHARGE_TYPE" },
          { "id": 330, "name": "Delete", "value": "DELETE_CHARGE_TYPE" }
        ]
      },
      {
        module: 'Master: Notifications', id: 46,visible:true,
        items: [
          { id: 46, name: 'Create', value:"CREATE_USER_NOTIFICATION"},
          { id: 46, name: 'Retrieve', value:"RETRIEVE_USER_NOTIFICATION"},
          { id: 46, name: 'Update', value:"UPDATE_USER_NOTIFICATION"},
          { id: 46, name: 'Delete', value:"DELETE_USER_NOTIFICATION"},
          { id: 46, name: 'View', value:"VIEW_USER_NOTIFICATION_LIST"}
        ]
      },
    ]
 
  }

  export enum DocStatus {
    "RECEIVED" = 5,
    "WAITING FOR EXTRACTION" = 10,
    "EXTRACTED" = 15,
    "PENDING VALIDATION" = 20,
    "VALIDATED" = 25,
    "AUDIT ERROR" = 30,
    "ON HOLD" = 35,
    "REVIEW" = 40,
    "DISCARDED" = 45,
    "REJECTED" = 50,
    "SENDING TO DESTINATION" = 55,
    "COMPLETED" = 60,
    "WAITING FOR ACKNOWLEDGEMENT" = 65,
    "APPROVED" = 70,
    "VALIDATION ERROR" = 75,
    "VALIDATION SUCCESS" = 80,
    "EXTRACTION ERROR" = 90,
    "AUDIT IN PROGRESS" = 85, 
    "MANUALLY APPROVED" = 95
  }

  export const DocGroupStatuses = {
    'New': [5, 10, 15, 20] ,
    'Valid Invoices': [25, 85] ,
    'Discrepancy': [40, 30] ,
    'Invalid Invoices': [90, 75] ,
    'Approved': [70, 95] ,
    'Rejected': [50] ,
    'Cancelled': [45] 
  }

  export enum CardStatus {
    "New" = 5,
    "Valid Invoices" = 15,
    "Discrepancy" = 30,
    "Invalid Invoices" = 90,
    "Approved"= 70,
    "Rejected" = 50,
    "Cancelled" = 45
  }

  export enum AuditStatus {
    "Pending" = 1,
    "Auto Approved" = 2,
    "Reject" = 5
  }

  
  export enum ActionsOnDoc {
    "REPROCESS" = 3,
    "RESCAN" = 5,
    "REJECT" = 6,
    "DISCARD" = 7,
    "APPROVE" = 8,
    "REVERT" = 10
  }
  
  export enum EmailType {
    "REPLY" = 1,
    "FORWARD" = 2,
    "RETURN" = 3,
    "USER SIGNUP" = 4,
    "USER APPROVAL" = 5,
    "REJECTION" = 6,
    "ERROR" = 7,
    "ASSIGNMENT" = 8,
    "NOTIFICATION" = 9
  }
  export enum FileType {
    "EDI" = 2,
    "PDF" = 1,
    "XML" = 3
  }

  export enum Module {
    DOCUMENTS = 5,
    USER_MANAGEMENT = 10,
    ROLE_MANAGEMENT = 15,
    ANNOUNCEMENT_MANAGEMENT = 45,
    CONTRACT_MANAGEMENT = 50,
    RATE_CARD_MANAGEMENT = 55,
    PO_MANAGEMENT = 60,
    PO_ITEM_MANAGEMENT = 61,
    SHIPMENT_MANAGEMENT = 65,
    CURRENCY_EXCHANGE = 70,
    CONFIG_MANAGEMENT = 80,
    USER_ACTIVITY_LOGS = 85,
    COUNTRY_MANAGEMENT = 95,
    CONNECTIVITY = 115,
    CURRENCY_MANAGEMENT = 125,
    AUTO_EMAIL_TEMPLATE = 130,
    MANUAL_EMAIL_TEMPLATE = 135,
    EMAIL_TEMPLATE_CONTROLLER = 140,
    CURRENCY_ALIAS = 145,
    ZIP_ALIAS = 155,
    VAT_ALIAS = 165,
    ERROR_CODE_LIST = 170,
    DOCUMENT_ACTIONS = 190,
    BILLING = 200,
    CHARGE_TYPE = 330,
    UOM_MANAGEMENT = 230,
    CUSTOMER_MANAGEMENT = 240,
     CUSTOMER_SBU_MANAGEMENT = 245,
    // VENDOR_MANAGEMENT = 250,
    SECTOR_MANAGEMENT = 260,
    BRE_CONFIG = 270,
    VALIDATION_MODULE = 280,
    VENDOR_MANAGEMENT = 255,
    SURCHARGES_MANAGEMENT = 320,
    SURCHARGE_CODE_LIBRARY = 350,
    SURCHARGE_TOLERANCE = 355
  }

  export enum ColumnSettingModule {
    INVOICE_MANAGEMENT = Module.DOCUMENTS,
    USER_MANAGEMENT = Module.USER_MANAGEMENT,
    ROLE_MANAGEMENT = Module.ROLE_MANAGEMENT,
    // ANNOUNCEMENT_MANAGEMENT = Module.ANNOUNCEMENT_MANAGEMENT,
    // CONTRACT_MANAGEMENT = Module.CONTRACT_MANAGEMENT,
    RATE_CARD_MANAGEMENT = Module.RATE_CARD_MANAGEMENT,
    // PO_MANAGEMENT = Module.PO_MANAGEMENT,
    // PO_ITEM_MANAGEMENT = Module.PO_ITEM_MANAGEMENT,
    SHIPMENT_MANAGEMENT = Module.SHIPMENT_MANAGEMENT,
    // CURRENCY_EXCHANGE = Module.CURRENCY_EXCHANGE,
    // CONFIG_MANAGEMENT = Module.CONFIG_MANAGEMENT,
    // USER_ACTIVITY_LOGS = Module.USER_ACTIVITY_LOGS,
    // COUNTRY_MANAGEMENT = Module.COUNTRY_MANAGEMENT,
    // CONNECTIVITY = Module.CONNECTIVITY,
    // CURRENCY_MANAGEMENT = Module.CURRENCY_MANAGEMENT,
    // AUTO_EMAIL_TEMPLATE = Module.AUTO_EMAIL_TEMPLATE,
    // MANUAL_EMAIL_TEMPLATE = Module.MANUAL_EMAIL_TEMPLATE,
    // EMAIL_TEMPLATE_CONTROLLER = Module.EMAIL_TEMPLATE_CONTROLLER,
    // CURRENCY_ALIAS = Module.CURRENCY_ALIAS,
    // ZIP_ALIAS = Module.ZIP_ALIAS,
    // VAT_ALIAS = Module.VAT_ALIAS,
    // ERROR_CODE_LIST = Module.ERROR_CODE_LIST,
    // DOCUMENT_ACTIONS = Module.DOCUMENT_ACTIONS,
    // BILLING = Module.BILLING,
    CHARGE_TYPE = Module.CHARGE_TYPE,
    UOM_MANAGEMENT = Module.UOM_MANAGEMENT,
    CUSTOMER_MANAGEMENT = Module.CUSTOMER_MANAGEMENT,
    CUSTOMER_SBU_MANAGEMENT = Module.CUSTOMER_SBU_MANAGEMENT,
    // SECTOR_MANAGEMENT = Module.SECTOR_MANAGEMENT,
    // BRE_CONFIG = Module.BRE_CONFIG,
    // VALIDATION_MODULE = Module.VALIDATION_MODULE,
    VENDOR_MANAGEMENT = Module.VENDOR_MANAGEMENT,
    SURCHARGES_MANAGEMENT = Module.SURCHARGES_MANAGEMENT,
    SURCHARGE_CODE_LIBRARY = Module.SURCHARGE_CODE_LIBRARY,
    SURCHARGE_TOLERANCE = Module.SURCHARGE_TOLERANCE
  }


  export enum ClientModule {
    USER_MANAGEMENT = 10,
    ANNOUNCEMENT_MANAGEMENT = 45,
    CURRENCY_EXCHANGE = 70,
    CURRENCY_MANAGEMENT = 125,
    ROLE_MANAGEMENT = 15,
    CLIENT_MANAGEMENT = 90,
    DOCUMENT_TYPE = 100,
    // FILE_TYPE = 105,
    RATE_SHEET = 110,
    BILLING = 200,
  }

  export enum DataChangeLoggerModule {
    "DOCUMENTS" = 10
  }
  export enum MasterModule {
    "EXTRACTED DATA" = 2,
    "DOCUMENTS" = 5,
    "USER MANAGEMENT" = 10,
    "ROLE MANAGEMENT" = 15,
    "PERMISSION MANAGEMENT" = 20,
    "ROLE PERMISSION MANAGEMENT" = 25,
    "ROLE USER MANAGEMENT" = 30,
    "COMPANY MANAGEMENT" = 35,
    "COMPANY USER MANAGEMENT" = 40,
    "ANNOUNCEMENT MANAGEMENT" = 45,
    "NOTIFICATION MANAGEMENT" = 46,
    "CONTRACT MANAGEMENT" = 50,
    "RATE CARD MANAGEMENT" = 55,
    "PO MANAGEMENT" = 60,
    "PO ITEM MANAGEMENT" = 61,
    "SHIPMENT MANAGEMENT" = 65,
    "CURRENCY EXCHANGE" = 70,
    "CONFIG MANAGEMENT" = 80,
    "USER ACTIVITY LOGS" = 85,
    "CLIENT MANAGEMENT" = 90,
    "COUNTRY MANAGEMENT" = 95,
    "DOCUMENT TYPE" = 100,
    "FILE TYPE" = 105,
    "RATE SHEET" = 110,
    "CONNECTIVITY" = 115,
    "BUSINESS UNIT" = 120,
    "CURRENCY MANAGEMENT" = 125,
    "AUTO EMAIL TEMPLATE" = 130,
    "MANUAL EMAIL TEMPLATE" = 135,
    "EMAIL TEMPLATE CONTROLLER" = 140,
    "CURRENCY_ALIAS" = 145,
    "COMPANY_ALIAS" = 150,
    "ZIP_ALIAS" = 155,
    "CITY_ALIAS" = 160,
    "VAT_ALIAS" = 165,
    "ERROR_CODE_LIST" = 170,
    "DOCUMENT_ACTIONS" = 190,
    "BILLING" = 200,
    "CHARGE_TYPE" = 330,
    "UOM_MANAGEMENT" = 230,
    "CUSTOMER_MANAGEMENT" = 240,
    "VENDOR_MANAGEMENT" = 250,
    "SECTOR_MANAGEMENT" = 260,
    "BRE_CONFIG" = 270,
    "VALIDATION_MODULE" = 280,
    "LSP_MANAGEMENT" = 255
  }



  export enum EnvironmentType {
    "DEV" = 1,
    "PROD" = 2,
    "TEST" = 3,
    "UAT" = 4,
    "TRAIN" = 5
  }
  export abstract class RegexPattern {
    public static readonly removeSpace: any = /^(?!\s+$).+/;
    public static readonly whiteSpace: any = /^(?!\s*$)[\s\S]+/;
    public static readonly validMultipleEmail: any = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    public static readonly validEmail: any = /^(?! )[a-zA-Z0-9_\.#$%&^`{|}~\+\-/\!\'*\+\-\/=\?\"]+@([a-zA-Z0-9-]+[.]){1,2}[a-zA-Z]+ *$/;
    public static readonly validPhone: any = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,50}$/;
    public static readonly removeSpecialCharacters: any = /^[a-zA-Z0-9]{4,10}$/;
    public static readonly DomainRegex = /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    public static readonly MultipleValidEmail: any = /^([a-zA-Z0-9+.\-\_]+@[a-zA-Z0-9\-\_]+\.[a-zA-Z0-9.\-\_]+)((,| ,|, | , |){1}[a-zA-Z0-9+.\-\_]+@[a-zA-Z0-9\-\_]+\.[a-zA-Z0-9.\-\_]+)*$/;
  }

  export enum UserTypeEnum {
    "COZENTUS_USER" = '5',
    "INTERNAL_USER" = '10',
    "EXTERNAL_USER" = '15',
   
  }

  export enum ApplicableTypeEnum {
    "ORIGIN" = "5",
    "DESTINATION" = "10",
    "PART_OF_FREIGHT" = "15"
  }

  export enum RateCardTypeEnum {
    "MAIN" = "5",
    "PRE" = "10",
    "POST" = "15"
  }
  export enum LoadTypeEnum {
  FTL = "5",
  AIR = "10",
  RFCL = "15",
  RLCL = "20",
  FCL = "25",
  LCL = "30",
  LTL = "35"
}
export abstract class LoadType {
  public static readonly LoadType: { id: number; name: string }[] = [
    { id: 5, name: "FTL" },
    { id: 10, name: "AIR" },
    { id: 15, name: "RFCL" },
    { id: 20, name: "RLCL" },
    { id: 25, name: "FCL" },
    { id: 30, name: "LCL" },
    { id: 35, name: "LTL" }
  ];
}

  export enum ExtractionFieldErrorEnum {
    "BOOKING REFERENCE NO" = 5,
    "MBL NO" = 10,
    "HBL NO" = 15,
    "TRANSPORT REFERENCE NUMBER" = 20,
    "CUSTOMER NAME" = 25,
    "VENDOR NAME" = 30,
    "SURCHARGE CODE" = 35,
    "SURCHARGE DESCRIPTION" = 40,
    "SURCHARGE AMOUNT" = 45,
    "CURRENCY" = 50
  }

  export enum SupportingDocsUploadType {
    "BILL OF LADING" = 5,
    "INVOICE" = 10,
    "PL" = 15,
    "RECEIPT" = 10
  }
  export abstract class ApplicableType{
    public static readonly ApplicableType: {id: number, name: string}[] = [{ id: 5, name: "ORIGIN" }, { id: 10, name: "DESTINATION" },{id:15,name:"PART OF FREIGHT"}]
  }
   export abstract class LspType {
    public static readonly LSPList: {}[] = [{ id: 5, name: "2PL" }, { id: 10, name: "3PL" }]
  }

  export const ToleranceOperators = [
    { id: 5, key: '>', value: 5, label: '> (Greater Than)', name: '>' },
    { id: 10, key: '<', value: 10, label: '< (Less Than)', name: '<' },
    { id: 15, key: '=', value: 15, label: '= (Equal To)',  name: '=' },
    { id: 20, key: '>=', value: 20, label: '>= (Greater Than or Equal To)', name: '>=' },
    { id: 25, key: '<=', value: 25, label: '<= (Less Than or Equal To)',  name: '<=' }
  ];


}